<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Lock & Un-Lock Panel</b-navbar-brand>
        </b-navbar>

        <b-card>
          <md-layout md-gutter>
            <md-layout md-flex="25" md-flex-small="100"  >
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale">
              </date-range-picker>
            </md-layout>
            <md-layout md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name">
              </model-list-select>
              
            </md-layout>
            <md-layout md-flex="25" md-flex-small="100">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="InvoiceNoFilter"
                placeholder="Invoice Number">
              </b-form-input>
            </md-layout> 
           <md-layout md-flex="25" md-flex-small="100">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="SBFilter"
                placeholder=" Shipping Bill No.">
              </b-form-input>
            </md-layout>
          </md-layout>  
          <md-layout md-gutter class="mt-2">
            <md-layout  md-flex="25" md-flex-small="100">
              <b-form-input :formatter="capitalizeAll"
                v-model="ContainerFilter"
                placeholder=" Container  No.">
              </b-form-input>
            </md-layout> 
            <md-layout  md-flex="25" md-flex-small="100">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="shiperInvFilter"
                placeholder=" Shipper Inv No.">
              </b-form-input>
            </md-layout> 
            <md-layout  md-flex="25" md-flex-small="100">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="assignmentFilter"
                placeholder=" Assignment No.">
              </b-form-input>
            </md-layout>
            <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType">
              </model-list-select>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="mt-2">
            <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch">
              </model-list-select>
            </md-layout>
            <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="invoiceStatusList"
                v-model="statusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status">
              </model-list-select>
            </md-layout>
            <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="SOBStatusList"
                v-model="SOBFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SOB Status">
              </model-list-select>
            </md-layout>
            <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="BillingStatusList"
                v-model="BillingFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Billing Status">
              </model-list-select>
            </md-layout>
            <md-layout md-flex="100">
              <b-form-group   class="mt-3" >
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="jobRecFilter"
                  :options="jobRecList"
                  name="flavour-1">
                </b-form-checkbox-group>
              </b-form-group>
            </md-layout>
          </md-layout>      
          <md-layout md-gutter class="justify-content-center mt-3">
            <b-button
              size="sm"
              @click="filterSearch"
              variant="outline-primary">Search</b-button>
            <b-button
              size="sm"
              class="ml-3"
              @click="clearFilter"
              variant="outline-info">clear</b-button>
            <b-button
              size="sm"
              class="ml-3"
              @click="getReports('All_UnlockPannel_SCREEN')"
              variant="outline-info">Export as Excel</b-button>
          </md-layout>
          <div class="gutr"></div>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="25"
              style="margin: 0px"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)">
            </b-pagination>
          </div>
          <div>
            <b-row class="align-content-end mt-3">
              <b-col cols="8">
                <input
                  type="checkbox"
                  @click="SelectAll(consoBooking)"
                  v-model="isCheckAll"/>
                <label>Select / Deselect All Count({{this.AllModule_ids.length}})</label>
                
              </b-col>
              <b-col cols="2">
                <h5 class="text-muted pull-right">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </b-col>
              <b-col cols="2" style="padding: 0px 1rem 0 5rem;">
                <model-list-select
                :list="PaginationList"
                v-model="PaginationCount"
                option-value="pagv"
                option-text="pagt"
                placeholder="Select"
                @input="pagechangeData()">
                </model-list-select>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive tableMain mt-2">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection">
              <template slot="jobType" slot-scope="row0">
              <input
                v-if="row0.item.revisedActionTakenFromMail !=1"
                type="checkbox"
                v-bind:value="row0.item.allModuleId"
                v-bind:id="row0.item.TPTClient"
                v-model="AllModule_ids"
                @change="updateSelectAll($event,row0.item)" />
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row0.item.allModuleId" :jb_series="row0.item.mainSalesSeries" />
              </template>
              <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.invoiceNoCreated">
                  <span
                    v-for="(item3, index) in row1000.item.invoiceNoCreated.split(',')"
                    :key="index">
                    <h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6>
                  </span>
                </div>
                <span v-else>{{row1000.item.multibillingSeries}}</span>
              </template>
              
              <template slot="mainSalesSeries" slot-scope="row1">
                <md-icon>{{
                  row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <b>{{ row1.item.mainSalesSeries }}</b>
                <br />
                <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ? "Sea" : "Air"
                  }}
                  {{ row1.item.transportType }})</span>
                <br />
                <span>Assignment Dt. :
                  {{ row1.item.assignmentDate | moment }}</span>
                <br />
                <span>Lock Date. :
                  {{ row1.item.all_lock_date_time | moment }}</span>
                <br />
                <!-- <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> <br />
                <span v-if="row1.item.sob_date_detected !='' && row1.item.sob_date_detected !=null" ><b :style="'color:black'">SOB : {{ row1.item.sob_date_detected }}</b> <b-badge variant="danger"><b>SAILED</b></b-badge></span>
                <br /> -->
                <!-- <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info">Summary & Documents</b-button>
                <br />
                <h7 class="mt-2" v-if="row1.item.splitFromId!='0'"><b-badge variant="info">Split of {{row1.item.splitFromNo}}</b-badge> </h7> -->
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' &&
                    row11.item.transportType == 'Export'
                  ">
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')">
                  FF :-
                  {{
                    row2.item.ffInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br/></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')">
                  CC :-
                  {{
                    row2.item.ccInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')">TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}</span>
              </template>
              <template slot="containerNo" slot-scope="row15">
                
                <div v-if="row15.item.containerNo">
                  
                  <span
                    v-for="(item1, index) in row15.item.containerNo.split(',')"
                    :key="index">
                    <h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6></span>
                                      <span
                    v-for="(item2, index) in row15.item.containerType.split(',')"
                    :key="index">
                    <h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}
                      </b-badge>
                    </h6></span>
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="shipperInv" slot-scope="row150">
                <div v-if="row150.item.shipperInv">
                  <span
                    v-for="(item2, index) in row150.item.shipperInv.split(',')"
                    :key="index">
                    <h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}
                      </b-badge>
                    </h6></span >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="ShippingB" slot-scope="row100">
                <div v-if="row100.item.ShippingB">
                  <span
                    v-for="(item3, index) in row100.item.ShippingB.split(',')"
                    :key="index"><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span>
                </div>
                <span v-else>-----------</span>
              </template>

              <template slot="mainEnquiryId" slot-scope="row15">
                <b-button
                  @click="
                     proceedBilling(
                      row15.item.allModuleId,
                      row15.item.newContainerFlow,
                      row15.item.isConsolidation,
                      row15.item.mainSalesSeries
                    )"
                  variant="primary"
                  size="sm"
                  >{{
                    row15.item.finalBillingCompleted == "1"
                      ? "Show Billing"
                      : "Proceed To Billing"
                  }}</b-button
                ><br />
                <span v-if="row15.item.extrapayment_lockunlock_pannel.length>0">
                <b-button 
                  style="font-size: 0.675rem"
                  v-for="(EP_item, EP_index) in row15.item.extrapayment_lockunlock_pannel"
                    :key="EP_index"
                  size="sm" 
                  text="View Mult-Billing" 
                  class="m-2"
                  variant="outline-info"
                  @click="showextra_paymentModal(EP_item.allModuleId,EP_item.email_contents,EP_item.doc_link,EP_item,row15.item.mainSalesSeries)"
                ><b v-if="EP_item.is_additional_task==1">Additional Task</b><b v-else-if="EP_item.is_expense==1">Expense Task</b><b v-else-if="EP_item.is_menifestation==1">Manifestation Task</b><b v-else-if="EP_item.is_slinepayment==1">Sline Payment Task</b></b-button>
                </span>
                <b-button
                  @click="ClearPayment(row15.item)"
                  size="sm"
                  style="font-size: 0.675rem"
                  variant="outline-danger"><b>Clear Payment</b></b-button>
                <br />
                <b-badge v-if="row15.item.frghtTermsMbl == 'Collect' && row15.item.frghtTermsHbl=='Collect'" class='p-2' variant="warning"><b>Credit Note Pending</b><br /> </b-badge>
                <b-badge class='p-2' variant="warning" 
                v-if="row15.item.uploadCreditDebit != '' && row15.item.approvalStatus=='1'"
                @click="PrintNote(row15.item.mainSalesSeries,row15.item.uploadCreditDebit)"
                size="sm"
                ><span v-if="row15.item.creditDebitNoteType=='1'">Credit Note </span>
                <span v-else>Debit Note </span>PDF<br/></b-badge>
                <b-badge
                  variant="warning"
                  v-if="row15.item.isConsolidation == '1'"
                  >Consolidation</b-badge
                >
                <!-- <b-badge
                  variant="success"
                  v-if="row15.item.finalBillingCompleted == '1'"
                  >Billing Completed</b-badge
                >
                <b-badge v-else variant="danger">Billing In-complete</b-badge> -->
                <b-badge variant="success" v-if="(row15.item.finalBillingCompleted == '1')">Billing Completed</b-badge>
                <b-badge v-else-if="row15.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge>
                <br />
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  v-if="row15.item.finalBillingCompleted != '1'"
                  size="sm"
                  @click="validateBilling(row15.item.allModuleId,row15.item.jobType)"
                  variant="outline-info"
                  >Close Billing</b-button
                >
                <b-button 
                  style="font-size: 0.675rem"
                  v-if="row15.item.isMultiBilling==1" 
                  size="sm" 
                  text="View Mult-Billing" 
                  class="m-2"
                  variant="outline-info"
                  @click="viewMultiBillingDetails(row15.item.allModuleId,row15.item.multibillingSeries,row15.item)"
                >View Mult-Billing</b-button><br/>
                <span style="color:green" v-html="row15.item.assignmentCloseReason" v-if="row15.item.assignmentCloseReason">{{wordWrap(row15.item.assignmentCloseReason,12)}}</span><br/>
                <Add-Message  :fk_all_module_id="row15.item.allModuleId" style="list-style-type: none;"/>
                <!-- <span class="error" v-if="row15.item.revisedActionTakenFromMail == '2'">Request Rejected</span> -->

               
                
                <!-- <b-button
                  :disabled="row15.item.sentForRevisedApproval == '1' ? true : false"
                  @click="openPopRevised(row15.item.sentForRevisedApproval,row15.item.allModuleId,row15.item.mainSalesSeries)"
                  size="sm"
                  style="font-size: 0.675rem"
                  variant="warning"
                  v-if="row15.item.finalBillingCompleted == '1'">Revised Billing Request</b-button> -->

                

                <!-- <span
                class="error"
                v-if="row15.item.revisedActionTakenFromMail == '2'">Request Rejected</span>
              <span
                class="error"
                v-if="row15.item.sentForRevisedApproval == '1'">Sent For Approval</span> -->
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      :title="PaymentClearTIT?PaymentClearTIT:'Submit Your Reason'"
      centered 
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
    <h3 v-if="PaymentClearTIT">{{PaymentClearTIT}}</h3>
    <h3 v-else>Confirmation</h3>

    <h4 class="error" v-if="PaymentClearMsg">{{PaymentClearMsg}}</h4>
    <h4 class="error" v-else><small>Invoice Not added for </small> {{incompleteJobBill}}  <small> Please Kindly Check..!</small></h4>
      <form ref="form">
        <b-row v-if="close_type == 'Payment Clear'">
          <b-col>
            <label>Remark:</label>
            <model-list-select
                class="ml-3"
                :list="lockClearStatusList"
                v-model="payment_clear_remark"
                option-value="value"
                option-text="text"
                placeholder="Select Remark">
              </model-list-select>
          </b-col>
        </b-row>
        <b-form-group
          :label="PaymentClearTIT"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
        <b-form-textarea :formatter="capitalizeAll"
          rows="5"
          id="name-input"
          v-model="closingReason"
          required
          ></b-form-textarea>
        </b-form-group>
      </form>
      <b-button @click="closeModalConfirm" variant="danger" class="pull-right"> Cancel</b-button>
      <b-button v-if="close_type == 'Payment Clear'" :disabled="payment_clear_remark?false:true" variant="success" @click="closeBillOk"> {{PaymentClearTIT?'Clear Payment':'Confirm & Close Billing'}}</b-button>
      <b-button v-else :disabled="closingReason?false:true" variant="success" @click="closeBillOk"> {{PaymentClearTIT?'Clear Payment':'Confirm & Close Billing'}}</b-button>
      
    </b-modal>

    <!-- Additional Extra Payment Modal Start -->
    <b-modal
      id="modal-extra_payment"
      ref="modal-extra_payment"
      title="Extra Payment Details"
      size="xl"
      centered 
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <CustomLoader v-if="extra_payment_loading" :width="50"></CustomLoader>
      
      <div v-if="extra_payment_error" class="alert alert-danger">
        <strong>Error:</strong> {{ extra_payment_error }}
      </div>

      <div v-if="extra_payment_data && !extra_payment_loading">
        <!-- Title -->
        <h3 v-if="extra_payment_Title" class="mb-3">{{extra_payment_Title}}</h3>

        <!-- Job Details -->
        <!-- <b-card v-if="extra_payment_data.jobDetails" class="mb-3">
          <h5 class="card-title">Job Details</h5>
          <b-row>
            <b-col md="6">
              <p><strong>Job No:</strong> {{ extra_payment_data.jobDetails.JobNo }}</p>
              <p><strong>Job Type:</strong> {{ extra_payment_data.jobDetails.JobType }}</p>
              <p><strong>Transport Type:</strong> {{ extra_payment_data.jobDetails.TransportType }}</p>
              <p><strong>Shipment Type:</strong> {{ extra_payment_data.jobDetails.ShipmentType }}</p>
            </b-col>
            <b-col md="6">
              <p><strong>Client Name:</strong> {{ extra_payment_data.jobDetails.ClientName }}</p>
              <p><strong>Shipping Line:</strong> {{ extra_payment_data.jobDetails.ShippingLine }}</p>
              <p><strong>Branch:</strong> {{ extra_payment_data.jobDetails.Branch }}</p>
              <p><strong>Job Date:</strong> {{ extra_payment_data.jobDetails.JobDate | moment }}</p>
            </b-col>
          </b-row>
        </b-card> -->

        <!-- Email Contents -->
        <b-card class="mb-3">
          <h5 class="card-title">Email Contents</h5>
          <div v-html="extra_payment_data.email_contents || extra_payment_Arr"></div>
          <!-- <div v-if="extra_payment_data.email_contents_clean && extra_payment_data.email_contents_clean !== extra_payment_data.email_contents" class="mt-2">
            <small class="text-muted">{{ extra_payment_data.email_contents_clean }}</small>
          </div> -->
        </b-card>

        <!-- Remarks -->
        <!-- <b-row v-if="extra_payment_data.email_remark || extra_payment_data.reviewed_remark || extra_payment_data.payment_clear_remark" class="mb-3">
          <b-col md="4" v-if="extra_payment_data.email_remark">
            <b-card>
              <h6>Email Remark</h6>
              <p>{{ extra_payment_data.email_remark }}</p>
            </b-card>
          </b-col>
          <b-col md="4" v-if="extra_payment_data.reviewed_remark">
            <b-card>
              <h6>Reviewed Remark</h6>
              <p>{{ extra_payment_data.reviewed_remark }}</p>
            </b-card>
          </b-col>
          <b-col md="4" v-if="extra_payment_data.payment_clear_remark">
            <b-card>
              <h6>Payment Clear Remark</h6>
              <p>{{ extra_payment_data.payment_clear_remark }}</p>
            </b-card>
          </b-col>
        </b-row> -->

        <!-- Supporting Documents -->
        <b-card v-if="extra_payment_data.doc_links_with_urls && extra_payment_data.doc_links_with_urls.length > 0" class="mb-3">
          <h5 class="card-title">Supporting Documents</h5>
          <div v-for="(doc, index_doc) in extra_payment_data.doc_links_with_urls" :key="index_doc">
            <a href="javascript:void(0)" @click.prevent="openSignedDocument('ASSIGNMENT_UPLOADS/' + extra_payment_folder.replaceAll('/', '_') + '/' + doc.link)" class="mr-3">
              View Document - {{ index_doc + 1 }} ({{ doc.link }})
            </a>
            <br/>
          </div>
        </b-card>

        <!-- Related Purchase Expenses -->
        <!-- <b-card v-if="extra_payment_data.relatedPurchaseExpenses && extra_payment_data.relatedPurchaseExpenses.length > 0" class="mb-3">
          <h5 class="card-title">Related Purchase Expenses ({{ extra_payment_data.relatedPurchaseExpensesCount }})</h5>
          <div class="table-responsive">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Transaction No</th>
                  <th>Payment Type</th>
                  <th>Ledger</th>
                  <th>Inv Amount</th>
                  <th>Selling Amount</th>
                  <th>Currency</th>
                  <th>Inv Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(exp, expIndex) in extra_payment_data.relatedPurchaseExpenses" :key="expIndex">
                  <td>{{ exp.ape_transaction_no }}</td>
                  <td>{{ exp.payment_type_str }}</td>
                  <td>{{ exp.ledger }}</td>
                  <td>{{ exp.inv_amt }}</td>
                  <td>{{ exp.selling_amt }}</td>
                  <td>{{ exp.currency_code }}</td>
                  <td>{{ exp.inv_date | moment }}</td>
                  <td>
                    <b-badge :variant="exp.is_payment_done ? 'success' : 'warning'">
                      {{ exp.is_payment_done ? 'Paid' : 'Pending' }}
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card> -->

        <!-- User Information -->
        <!-- <b-row class="mb-3">
          <b-col md="4" v-if="extra_payment_data.createdBy">
            <b-card>
              <h6>Created By</h6>
              <p><strong>Name:</strong> {{ extra_payment_data.createdBy.employeeName }}</p>
              <p><strong>Email:</strong> {{ extra_payment_data.createdBy.email }}</p>
            </b-card>
          </b-col>
          <b-col md="4" v-if="extra_payment_data.reviewedBy && extra_payment_data.reviewedBy.userId">
            <b-card>
              <h6>Reviewed By</h6>
              <p><strong>Reviewed At:</strong> {{ extra_payment_data.reviewed_at | moment }}</p>
            </b-card>
          </b-col>
          <b-col md="4" v-if="extra_payment_data.clearedBy && extra_payment_data.clearedBy.userId">
            <b-card>
              <h6>Cleared By</h6>
              <p><strong>Name:</strong> {{ extra_payment_data.clearedBy.employeeName }}</p>
              <p><strong>Email:</strong> {{ extra_payment_data.clearedBy.email }}</p>
            </b-card>
          </b-col>
        </b-row> -->

        <!-- Status Badges -->
        <!-- <div class="mb-3">
          <b-badge :variant="extra_payment_data.is_reviewed ? 'success' : 'warning'" class="mr-2">
            {{ extra_payment_data.is_reviewed ? 'Reviewed' : 'Not Reviewed' }}
          </b-badge>
          <b-badge :variant="extra_payment_data.isActive ? 'success' : 'danger'" class="mr-2">
            {{ extra_payment_data.isActive ? 'Active' : 'Inactive' }}
          </b-badge>
        </div> -->
      </div>

      <b-button @click="closeextra_payment" variant="danger" class="pull-right"> Close</b-button>
    </b-modal>
    <!-- Additional Extra Payment Modal End -->

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMailRevised"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopTally"
    ></md-dialog-confirm>
        <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose1"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeconsolidationTXTOk"
      ref="addPopClose"
    ></md-dialog-confirm>
    
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import {DateFormat, selectDateFormat, wordWrap} from "../../helper/filters"
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "./docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import PaymentRequestService from "../../services/PaymentRequestService.js";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    let viewmultiBill_allModuleID = this.$sessionsStorage.get("viewmultiBill_allModuleID");
    let multibillingSeries = this.$sessionsStorage.get("viewmultiBill_billingSeries");
    // 
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute","/viewBillingDetails/viewAllMultiBillingDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewAllMultiBilllingList("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      //Added By Priyanshu Singh Multi Select Start
      extra_payment_Title:"",
      extra_payment_Arr:"",
      extra_payment_doc:"",
      extra_payment_folder:"",
      extra_payment_allModuleId:"",
      extra_payment_jobNo:"",
      extra_payment_loading: false,
      extra_payment_data: null,
      extra_payment_error: null,
      close_type:"Billing",
      PaymentClearTIT:"",
      PaymentClearMsg:"",

      revisedmailIDS :[],
      revisedJobNo :[],
      isCheckAll: false,
      AllModule_ids: [],
      AllClient_ids: [],
      AllJobNo_Series:[],
      selectedAllModule_ids: "",
      selectedClient_ids: "",
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      //Added By Priyanshu Singh Multi Select Start
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason:"",
      payment_clear_remark:"",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Invoice No. ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        {
          key: "ffInvoiceClosed",
          mainkey: "ffInvoiceClosed",
          label: "Execution Invoice",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },


        // {
        //   key: "tptInvoiceClosed",
        //   mainkey: "tptInvoiceClosed",
        //   label: "Invoice Status",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Billing",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "show_details",
        //   mainkey: "tptInvoiceClosed",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],
      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      ContainerFilter: "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: "2",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      clientMaster: [],
      reload: true,
      lockClearStatusList: [
        { value: 'Billed', text: 'Billed' },
        { value: 'Not to be Billed', text: 'Not to be Billed' },
        // { value: 'PENDING For LATER', text: 'PENDING For LATER' },
      ],
      jobRecList: [
        { value: '0', text: 'TPT Received' },
        { value: '1', text: 'CC Received' },
        { value: '2', text: 'FF Received' },
      ],
      PaginationList:[
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        }
      ],
      PaginationCount:"",
      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
{
          inv: "3",
          int: "No-Billing",
        },
      ],
       SOBFilter:"3",
       SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
       BillingFilter:"2",
       BillingStatusList: [
        {
          inv: "1",
          int: "Normal Billing",
        },
        {
          inv: "2",
          int: "Multi Billing",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},
  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
    AddMessage,
    AssignmentSummary,
  },

  computed: {},
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } 
        // else {
        //   this.statusFilter = "0";
        // }
      },
      deep: true,
    },
    InvoiceNoFilter: {
    handler: function (newVal, oldVal) {
      if (
        this.clientIdFilter ||
        this.shiperInvFilter ||
        this.InvoiceNoFilter ||
        this.SBFilter ||
        this.ContainerFilter ||
        this.jobTypeFilter ||
        this.branchfilter ||
        this.jobRecFilter ||
        this.assignmentFilter
      ) {
        this.statusFilter = "2";
      } 
      // else {
      //   this.statusFilter = "0";
      // }
    },
    deep: true,
    },
  },
  methods: {
    ClearPayment(item){
      this.PaymentClearTIT = '';
      this.close_type="Billing";
      this.selectedAllModuleId = item.allModuleId;
      this.PaymentClearTIT="Clear Payment Details";

      this.PaymentClearMsg = "Are you sure to Clear Payment Details ?";
      this.close_type = "Payment Clear"
      this.$refs['modal-close-conf'].show();
    },
    openPopRevised(sentForRevisedApproval,allModuleId,mainSalesSeries) {
      this.extra_payment_allModuleId = "";
      this.extra_payment_jobNo = "";
      this.extra_payment_jobNo = mainSalesSeries;
      this.extra_payment_allModuleId = allModuleId;
      if (sentForRevisedApproval == "1") {
        this.confirm.contentHtml = "Already Sent  for Approval..?";
      } else {
        this.confirm.contentHtml = "Send   for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    sendMailRevised(type) {
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          allModuleId: this.extra_payment_allModuleId,
          approvalMail: "approvalMail",
          executionNo: this.extra_payment_jobNo,
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/sendApprovalRevisedBilling.php`,
            data: JSON.stringify(newData),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.viewAllMultiBilllingList("0", "1", "1");
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    openPop(type,Arr) {
      this.revisedmailIDS = [];
      this.revisedJobNo = [];
      console.log("Arr=>",Arr);
      
      if(type == "single"){
        this.revisedmailIDS.push(Arr.allModuleId);
        this.revisedJobNo.push(Arr.mainSalesSeries);
      }else if(type == "multiple"){
        this.revisedmailIDS = this.AllModule_ids;
        this.revisedJobNo = this.AllJobNo_Series;
      }
      // console.log("revisedmailIDS=>",this.revisedmailIDS);
      // console.log("revisedJobNo=>",this.revisedJobNo);
      // return false;
      if (this.revisedmailIDS.length>0) {
        this.confirm.contentHtml = "Already Sent  for Approval..?";
      } else {
        this.confirm.contentHtml = "Send for Approval..?";
      }
      this.$refs["popMail"].open();
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          allModuleIdArr: this.revisedmailIDS,
          approvalMail: "approvalMail",
          JobNoArr: this.revisedJobNo,
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/sendMultiApprovalRevisedBilling.php`,
            data: JSON.stringify(newData),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              if (data.status_code == true) {
                this.alert.content = data.MSG;
              } else if(data.status_code == false) {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.viewAllMultiBilllingList("0", "1", "1");
            })
            .catch((error) => {});
        }
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    wordWrap,
    validateBilling(id,jobType){
      this.selectedAllModuleId = id;
      this.isLoading=true
      let payload = {
        allModuleId: id,
        job: jobType,

      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if(data.incompleteJobBill.length>0){
              this.incompleteJobBill=data.incompleteJobBill.toString();
              this.$refs['modal-close-conf'].show()
            }else{
              // alert("Hello");
              this.closeBill(id);
            }
            
            this.isLoading=false
          }
        })
        .catch((error) => {});
    },
    closeModalConfirm() {
      this.incompleteJobBill="",
      this.close_type="Billing";
      this.PaymentClearTIT = '';
      this.payment_clear_remark = '';
      this.$refs['modal-close-conf'].hide()
    },
    async showextra_paymentModal(allModuleId,email_contents,doc_link,item,mainSalesSeries) {
      // Reset data
      this.extra_payment_Title="";
      this.extra_payment_Arr="";
      this.extra_payment_doc="";
      this.extra_payment_folder = "";
      this.extra_payment_folder = mainSalesSeries;
      this.extra_payment_data = null;
      this.extra_payment_error = null;
      this.extra_payment_loading = true;

      // Set title based on item type
      if(item.is_additional_task == 1){
        this.extra_payment_Title="Additional Payment Task";
      }else if(item.is_expense == 1){
        this.extra_payment_Title="Expense Payment Task";
      }else if(item.is_menifestation == 1){
        this.extra_payment_Title="Manifestation Payment Task";
      }else if(item.is_slinepayment == 1){
        this.extra_payment_Title="Sline Payment Task";
      }
      
      // Fallback to passed parameters
      this.extra_payment_Arr=email_contents;
      this.extra_payment_doc=doc_link;

      // Show modal immediately
      this.$refs["modal-extra_payment"].show();

      try {
        // Prepare payload - use extrapayment_id if available, otherwise use allModuleId
        const payload = {};
        if (item.extrapayment_id) {
          payload.extrapayment_id = item.extrapayment_id;
        } else if (allModuleId) {
          payload.allModuleId = allModuleId;
        } else {
          throw new Error('Either extrapayment_id or allModuleId is required');
        }

        // Call Node API
        const response = await PaymentRequestService.getLockPanelEmailDetails(payload);
        
        if (response && response.data) {
          if (response.data.status === true && response.data.data) {
            this.extra_payment_data = response.data.data;
            
            // Update title if not set
            if (!this.extra_payment_Title) {
              if (this.extra_payment_data.is_additional_task) {
                this.extra_payment_Title = "Additional Payment Task";
              } else if (this.extra_payment_data.is_expense) {
                this.extra_payment_Title = "Expense Payment Task";
              } else if (this.extra_payment_data.is_menifestation) {
                this.extra_payment_Title = "Manifestation Payment Task";
              } else if (this.extra_payment_data.is_slinepayment) {
                this.extra_payment_Title = "Sline Payment Task";
              }
            }
          } else {
            this.extra_payment_error = response.data.message || 'Failed to fetch lock panel details';
          }
        } else {
          this.extra_payment_error = 'Invalid response from server';
        }
      } catch (error) {
        console.error('Error fetching lock panel details:', error);
        this.extra_payment_error = error.message || 'Failed to fetch lock panel details. Please try again.';
      } finally {
        this.extra_payment_loading = false;
      }
    },
    closeextra_payment(){
      this.extra_payment_Title="";
      this.extra_payment_Arr="";
      this.extra_payment_doc="";
      this.extra_payment_data = null;
      this.extra_payment_error = null;
      this.extra_payment_loading = false;
      this.$refs['modal-extra_payment'].hide();
    },
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      if (!ffExportFclSeries || !uploadCreditDebit) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        ffExportFclSeries.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    getReports(id) {
      this.isLoading=true;
      let excelIdGivin = "";
      if (id == "All_UnlockPannel_SCREEN") {
        excelIdGivin = "All_UnlockPannel_SCREEN";
      }
      let payload = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        SOBFilter:this.SOBFilter,
        BillingFilter:this.BillingFilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName =
          this.$store.getters["common/getAllPendingReverseTallyExcel"];
          this.isLoading=false;
      }

     
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    closeBill(id) {
      this.selectedAllModuleId = id;
      this.incompleteJobBill="addPopClose";

      this.alert.content = "Are you sure to close Assignment Billing ?";
      this.$refs["addPopClose1"].open();
    },
    closeBillOk(type) {
      if(type == "cancel"){
        this.incompleteJobBill="";
      }else if(type == "ok"){
        this.incompleteJobBill="InVoices Done";
      }

      let common_url = '';
      if(this.close_type == "Payment Clear"){
        common_url = "/Api_Common/clearPayment.php";
        this.closingReason = this.closingReason;
      }else if(this.close_type == "Billing"){
        common_url = "/Api_TallyBilling/closeBillingStatus.php";
        if(this.incompleteJobBill == "InVoices Done"){
        this.closingReason = "Direct Close InVoices Done";
      }
      }
      // alert(common_url);
      // alert(this.closingReason);
      // return false;
      if (this.closingReason) {
        this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
          closingReason: this.closingReason,
          payment_clear_remark:this.payment_clear_remark,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}`+common_url,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.viewAllMultiBilllingList("0", "1", "1");
              this.isLoading = false;
            }
              this.incompleteJobBill="",
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.close_type="Billing";
              this.PaymentClearTIT = '';
            this.$refs['modal-close-conf'].hide()
          })
          .catch((error) => {});
      }
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewAllMultiBilllingList(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewAllMultiBilllingList("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
      this.statusFilter = "2";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.SBFilter = "";
      this.SOBFilter="3";
      // this.BillingFilter="2";
      this.statusFilter = "2";
      this.dateRange={
        startDate: "",
        endDate: "",
      },
      this.viewAllMultiBilllingList("0", "1", "1");
    },
    proceedBilling(item, id,isConsolidation,mainSalesSeries) {
      this.$sessionsStorage.set("editSalesExId", item);
      if(isConsolidation == '1'){
        this.$router.push({
            path: "/consolidation/viewBillingDetails/"+ item,
            query: { mainSalesSeries: mainSalesSeries }
          });
      }else{
        if (id == "1") {
          this.$router.push({
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        } else {
          this.$router.push({
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        }
      }
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute",this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }
      this.viewAllMultiBilllingList(CURRENT, "2", event);
    },
    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },
    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.viewAllMultiBilllingList("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },
    viewAllMultiBilllingList(CURRENT, SEARCH, pageNumber) {
      // let allModuleID = this.$sessionsStorage.get("viewmultiBill_allModuleID");
      // let billingSeries = this.$sessionsStorage.get("viewmultiBill_billingSeries");
      this.consoBooking = [];
      this.isLoading = true;

      let payload = {
        allModuleID:'',
        billingSeries:'',
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        SOBFilter:this.SOBFilter,
        // BillingFilter:this.BillingFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/viewAllLockUnlockBillingList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            console.log("Priyanshu Singh=>",data)
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    //Added By Priyanshu SIngh Multi Select Start
    viewMultiBillingDetails(allModuleID,multibillingSeries,Arr){
        if(multibillingSeries !=undefined && multibillingSeries !=null && multibillingSeries!=''){
          this.$sessionsStorage.set("viewmultiBill_allModuleID", allModuleID);
          this.$sessionsStorage.set("viewmultiBill_billingSeries", multibillingSeries);
          this.$router.push({
            path: "/allModuleForm/viewMultiBillingDetails/",
          });
        }
    },
    ProceedMultiBilling() {
      let AllModule_ids_arr= this.AllModule_ids;
      let AllClient_ids_arr= this.AllClient_ids;
      let mainSalesSeries_arr= [];
      let newContainerFlow_arr= [];
      let isConsolidation_arr= [];
      let finalBillingCompleted_arr = [];
      let clientflag = AllClient_ids_arr.filter(x => AllClient_ids_arr[0] != x ).length
      
      if(clientflag >=1){
        this.alert.content = "Please Choose Only Same Client Details";
        this.$refs["addPop"].open();
        return false
      }
      this.consoBooking.forEach((sbook) => {
        AllModule_ids_arr.forEach((allmoduleARR) => {
          if(allmoduleARR == sbook.allModuleId){
            newContainerFlow_arr.push(sbook.newContainerFlow);
            isConsolidation_arr.push(sbook.isConsolidation);
            mainSalesSeries_arr.push(sbook.mainSalesSeries);
            finalBillingCompleted_arr.push(sbook.finalBillingCompleted);
          }
        })     
      })
      let flag = isConsolidation_arr.filter(x => isConsolidation_arr[0] != x ).length
      let finalBillingflag = finalBillingCompleted_arr.filter(x => finalBillingCompleted_arr[0] != x ).length
      if(finalBillingflag >=1){
        this.alert.content = "Please Choose only that Assignment Billing is pending.";
        this.$refs["addPop"].open();
        return false
      }
      if(flag >=1){
        this.alert.content = "Please Choose Either Consolidation Or Normal Assignment";
        this.$refs["addPop"].open();
        return false
      }
      let ContainerFlow_flag = newContainerFlow_arr.filter(x => newContainerFlow_arr[0] != x ).length
        if(ContainerFlow_flag >=1){
        this.alert.content = "Something went wrong Please Contact Support with Admin";
        this.$refs["addPop"].open();
        return false
      }
      this.proceedMultiTallyBilling(AllModule_ids_arr,newContainerFlow_arr,isConsolidation_arr,mainSalesSeries_arr);
    },
    proceedMultiTallyBilling(AllModule_ids_arr, newContainerFlow_arr,isConsolidation_arr,mainSalesSeries_arr) {
      this.$sessionsStorage.set("AllModule_ids_arr", AllModule_ids_arr);
      this.$sessionsStorage.set("mainSalesSeries_arr", mainSalesSeries_arr);
      this.$sessionsStorage.set("newContainerFlow_arr", newContainerFlow_arr);
      this.$sessionsStorage.set("isConsolidation_arr", isConsolidation_arr);
      let isconsflag = isConsolidation_arr.filter(x => isConsolidation_arr[0] == x ).length
      let consolidationTXT="";
      let Cont_FlowTXT="";
      isConsolidation_arr.forEach((consolidation) => {
        if(consolidation == 0){
          consolidationTXT="Normal";
        }else if(consolidation == 1){
          consolidationTXT="Consolidation";
        }
      }) 
      newContainerFlow_arr.forEach((Cont_Flow) => {
        if(Cont_Flow == 0){
          Cont_FlowTXT="Old";
        }else if(Cont_Flow == 1){
          Cont_FlowTXT="New";
        }
      }) 
      if(consolidationTXT == "Normal" || consolidationTXT == "Consolidation"){
        this.alert.content = "You have Chosen "+consolidationTXT+" Assignment";
        this.$refs["addPopClose"].open();
        this.$forceUpdate();
      }
    },
    closeconsolidationTXTOk(type) {
      let consolidationTXT="";
      let Cont_FlowTXT="";
      let isConsolidation_arr=[];
      let newContainerFlow_arr=[];
      if(this.$sessionsStorage.get("isConsolidation_arr") != null){
            isConsolidation_arr=this.$sessionsStorage.get("isConsolidation_arr").split(",");    
      }
      if(this.$sessionsStorage.get("newContainerFlow_arr") != null){
          newContainerFlow_arr=this.$sessionsStorage.get("newContainerFlow_arr").split(",");
      }
      let isconsflag = isConsolidation_arr.filter(x => isConsolidation_arr[0] == x ).length
      isConsolidation_arr.forEach((consolidation) => {
        if(consolidation == 0){
          consolidationTXT="Normal";
        }else if(consolidation == 1){
          consolidationTXT="Consolidation";
        }
      }) 
      newContainerFlow_arr.forEach((Cont_Flow) => {
        if(Cont_Flow == 0){
          Cont_FlowTXT="Old";
        }else if(Cont_Flow == 1){
          Cont_FlowTXT="New";
        }
      }) 
      
      if(type == "ok"){
        if(isconsflag == isConsolidation_arr.length){
          if(consolidationTXT == "Consolidation"){
            this.alert.content = "Sorry Consolidation Only Single Billing Allowed";
            this.$refs["addPop"].open();
          }else if(consolidationTXT == "Normal"){
            if (Cont_FlowTXT == "Old") {
              this.$router.push({
                path: "/allModuleForm/newTallyMultiBillingMerge/",
              });
            } else if (Cont_FlowTXT == "New") {
              this.$router.push({
                path: "/allModuleForm/newTallyMultiBillingMerge/",
              });
            }
          }
        }else{
            this.alert.content = "Please Choose Either Consolidation Or Normal Assignment";
            this.$refs["addPop"].open();
            return false
        }
      }
    },
    SelectAll: function () {
      this.isCheckAll = !this.isCheckAll;
      this.AllModule_ids = [];
      this.AllJobNo_Series = [];
      this.AllClient_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.consoBooking) {
          // row0.item.revisedActionTakenFromMail !=1
          if(this.consoBooking[key].revisedActionTakenFromMail != 1){
            let single_data = "";
            this.AllModule_ids.push(this.consoBooking[key].allModuleId);
            this.AllJobNo_Series.push(this.consoBooking[key].mainSalesSeries);
            this.AllClient_ids.push(this.consoBooking[key].TPTClient); 
          }
        }
      }
    },
    updateSelectAll: function (e,item) {
      if (this.AllModule_ids.length == this.consoBooking.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.AllModule_ids.includes(item.allModuleId);
      if(istrue == true){
        this.AllClient_ids.push(item.TPTClient);
        this.AllJobNo_Series.push(item.mainSalesSeries);
      }else{
        const index = this.AllClient_ids.indexOf(item.TPTClient);
        const JobNo_Series_index = this.AllJobNo_Series.indexOf(item.mainSalesSeries);
        this.AllClient_ids.splice(index, 1);
        this.AllJobNo_Series.splice(JobNo_Series_index, 1);
      }
      console.log("this.AllJobNo_Series=>",this.AllJobNo_Series);
    },
    pagechangeData() {
      this.perPage = this.PaginationCount;
      this.reload = false;
      this.viewAllMultiBilllingList("0", "1", "1");
    },
    checkCLient(TPTClient) {
        return TPTClient;
    }
    //Added By Priyanshu SIngh Multi Select End
  },
};
</script>



// WEBPACK FOOTER //
// viewAllUnlockPannelDetails.vue?67aa270f